export default __webpack_public_path__ + "static/media/mens.7e197e90.svg";